// extracted by mini-css-extract-plugin
export default {"backdrop":"Loader_backdrop__ERdwy","loader":"Loader_loader__s4N3W","slide-down":"Loader_slide-down__AY8mn","text-loader":"Loader_text-loader__MDTHr"};